import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import * as _ from 'lodash';
import { IQuote } from "./quotes.interface";
import { QuoteStatuses } from "./quotes.constants";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class QuotesHttpService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }

  getQuotes(filter?: IFilter): Observable<IQuote[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_QUOTES)}${queryParams}`).pipe(
      map(quotes => {
        return quotes.map((quote: any) => {
          quote.status = quote.status || QuoteStatuses.QUOTED;
          quote.details = quote.details.map((det: any) => {
            delete det.addBy; delete det.addByUser; return det;
          })
          return quote;
        });
      }));
  }

  getQuote(quote: any | string): Observable<IQuote> {
    let id = (typeof quote == 'string') ? quote : quote._id;
    return this._http.get(`${apiURL(EnvConfig.API_QUOTES)}/${id}`);
  }

  getRawQuote(quote: any | string): Observable<IQuote | any> {
    let id = (typeof quote == 'string') ? quote : quote._id;
    return this._http.get(`${apiURL(EnvConfig.API_QUOTES)}/raw/${id}`);
  }

  getQuotePDFURL(quote: any): string {
    let id = (typeof quote == 'string') ? quote : quote._id;
    return `${apiURL(EnvConfig.API_QUOTES)}/${id}/generatePDF`
  }

  getQuotePDFBlobURL(quote: any): string {
    let id = (typeof quote == 'string') ? quote : quote._id;
    return `${apiURL(EnvConfig.API_QUOTES)}/${id}/generatePDFBlob`
  }

  getQuotePDF(quote: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.getQuotePDFURL(quote);
      this._http.get(url, { responseType: "arraybuffer" }).subscribe(file => {
        resolve(this._utilsService.blobToObjectURL(file, "application/pdf"));
      });
    });
  }

  download(quote?: any) {
    // let numberQuote = quote?.number.toString().padStart(5, '0');
    let nameClietQuote = quote?.client.firstname;
    nameClietQuote = quote?.client.lastname ? nameClietQuote + " " + quote?.client.lastname : nameClietQuote;
    // let dueDate = quote?.dueDate.split('T')[0] ;
    let date =  quote?.date.split('T')[0].split('-').reverse().join('-');

    let fileNameDownload = 'P ' + quote?.number.toString() + ' ' + this._AuthService.company().name + ' ' + date + '.pdf'

    let query = { "company": this._AuthService.companyId() }
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_QUOTES)}/${quote._id}/generatePdf${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      console.log(file),
      this._utilsService.blobToFile(file, "application/pdf", fileNameDownload);
    });
  }

  sendEmail(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_QUOTES)}/${id}/sendEmail`, data);
  }

  createQuote(quote: IQuote): Observable<IQuote> {
    return this._http.post(`${apiURL(EnvConfig.API_QUOTES)}`, quote);
  }

  updateQuote(quote: IQuote): Observable<any> {
    let id = quote._id;
    delete quote._id;
    return this._http.patch(`${apiURL(EnvConfig.API_QUOTES)}/${id}`, quote);
  }

  deleteQuote(quote: IQuote | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof quote == 'string') ? quote : quote._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_QUOTES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_QUOTES)}/${id}/delete`);
  }

  restoreQuote(quote: IQuote | string): Observable<void> {
    let id = (typeof quote == 'string') ? quote : quote._id;
    return this._http.post(`${apiURL(EnvConfig.API_QUOTES)}/${id}/restore`, null);
  }
}